class SovereignAudioEngine {
  constructor() {
    this.ctx = null;
    this.oscL = null;
    this.oscR = null;
    this.gainNode = null;
    this.merger = null;
    this.isPlaying = false;
    this.currentMode = 'gamma';
  }

  initContext() {
    if (!this.ctx) {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (AudioCtx) {
        this.ctx = new AudioCtx();
      }
    }
    if (this.ctx && this.ctx.state === 'suspended') {
      this.ctx.resume();
    }
  }

  start(mode = 'gamma') {
    try {
      this.initContext();
      if (this.isPlaying || !this.ctx) return;

      this.currentMode = mode;
      const t = this.ctx.currentTime;

      // فرکانس‌های پایه و اختلاف فرکانس برای حالت‌های ذهنی مختلف
      // گاما (۴۰Hz) برای تمرکز عمیق و محاسبات | تتا (۶Hz) برای خلاقیت و آرامش
      let baseFreq = 174;
      let beatFreq = mode === 'gamma' ? 40 : 6;

      this.oscL = this.ctx.createOscillator();
      this.oscR = this.ctx.createOscillator();
      this.gainNode = this.ctx.createGain();
      this.merger = this.ctx.createChannelMerger(2);

      this.oscL.type = 'sine';
      this.oscR.type = 'sine';

      this.oscL.frequency.setValueAtTime(baseFreq, t);
      this.oscR.frequency.setValueAtTime(baseFreq + beatFreq, t);

      // تفکیک کانال چپ و راست برای اثرگذاری واقعی ضربان بینورال در هدفون
      this.oscL.connect(this.merger, 0, 0); // کانال چپ
      this.oscR.connect(this.merger, 0, 1); // کانال راست

      this.gainNode.gain.setValueAtTime(0.0001, t);
      this.gainNode.gain.exponentialRampToValueAtTime(0.2, t + 2);

      this.merger.connect(this.gainNode);
      this.gainNode.connect(this.ctx.destination);

      this.oscL.start();
      this.oscR.start();
      this.isPlaying = true;
    } catch (e) {
      console.warn('Binaural start error handled gracefully:', e);
    }
  }

  stop() {
    try {
      if (!this.isPlaying || !this.ctx || !this.gainNode) return;
      const t = this.ctx.currentTime;
      this.gainNode.gain.setValueAtTime(this.gainNode.gain.value, t);
      this.gainNode.gain.exponentialRampToValueAtTime(0.0001, t + 0.6);

      setTimeout(() => {
        if (this.oscL) {
          try { this.oscL.stop(); this.oscL.disconnect(); } catch (_) {}
          this.oscL = null;
        }
        if (this.oscR) {
          try { this.oscR.stop(); this.oscR.disconnect(); } catch (_) {}
          this.oscR = null;
        }
        this.isPlaying = false;
      }, 600);
    } catch (e) {
      console.warn('Binaural stop error handled gracefully:', e);
    }
  }

  toggle() {
    if (this.isPlaying) {
      this.stop();
    } else {
      this.start(this.currentMode);
    }
    return this.isPlaying;
  }

  playClickSfx() {
    try {
      this.initContext();
      if (!this.ctx) return;
      const osc = this.ctx.createOscillator();
      const gain = this.ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(520, this.ctx.currentTime);
      gain.gain.setValueAtTime(0.06, this.ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.0001, this.ctx.currentTime + 0.06);
      osc.connect(gain);
      gain.connect(this.ctx.destination);
      osc.start();
      osc.stop(this.ctx.currentTime + 0.06);
    } catch (_) {}
  }

  playSuccessSfx() {
    try {
      this.initContext();
      if (!this.ctx) return;
      const now = this.ctx.currentTime;
      [523.25, 659.25, 783.99, 1046.5].forEach((freq, i) => {
        const osc = this.ctx.createOscillator();
        const gain = this.ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, now + i * 0.08);
        gain.gain.setValueAtTime(0.08, now + i * 0.08);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.08 + 0.35);
        osc.connect(gain);
        gain.connect(this.ctx.destination);
        osc.start(now + i * 0.08);
        osc.stop(now + i * 0.08 + 0.35);
      });
    } catch (_) {}
  }
}

export const soundEngine = new SovereignAudioEngine();
export const liveSynth = soundEngine;
export default soundEngine;
